import { useEffect, useRef, useState } from 'react';

import { Translate } from '@spazious/dollhouse-i18n';
import { Flex, Typography } from '@spazious/dollhouse-uikit';
import { useEventCallback } from '@spazious/react-hooks';

import { DollhouseMessage, MainViewMessage } from '../../core/EventManager.js';
import { ConfirmDialog } from '../ConfirmDialog/index.js';
import { useEvents } from '../EventManager/index.js';

const CamerapathResetConfirmationForm = () => {
  return (
    <Flex gap="var(--spacing-gap)">
      <Typography variant="title">
        <Translate>
          Existing camera path will be removed. Are you sure you want to continue?
        </Translate>
      </Typography>
    </Flex>
  );
};

export const CamerapathResetDialog: React.FC = () => {
  const events = useEvents();
  const [open, setOpen] = useState(false);
  const confirmRef = useRef(false);

  const doClose = useEventCallback(() => {
    if (!confirmRef.current) {
      events.emit('mainViewMessage', MainViewMessage.CameraPathResetCancel);
    }
    setOpen(false);
  });

  const doConfirm = useEventCallback(() => {
    confirmRef.current = true;
    setOpen(false);
    events.emit('mainViewMessage', MainViewMessage.CameraPathResetConfirm);
  });

  useEffect(() => {
    const cb = (message: DollhouseMessage) => {
      if (message === DollhouseMessage.ConfirmCameraPathReset) {
        confirmRef.current = false;
        setOpen(true);
      }
    };
    events.on('dollhouseMessage', cb);
    return () => {
      events.off('dollhouseMessage', cb);
    };
  }, [events]);
  return (
    <ConfirmDialog
      fullWidth
      content={<CamerapathResetConfirmationForm />}
      maxWidth="600px"
      open={open}
      onClose={doClose}
      onConfirm={doConfirm}
    />
  );
};
